import { render, staticRenderFns } from "./core-program.vue?vue&type=template&id=67ed9ae8"
import script from "./core-program.vue?vue&type=script&lang=js"
export * from "./core-program.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports